.iconWrap {
  background: var(--vkui--color_background_content_alpha);
  border-radius: 6px;
  padding: 6px;
  box-sizing: border-box;
}
